import { createTheme } from '@mui/material/styles';
import { colors, radii } from './tokens';

export const muiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: colors.accent,
      contrastText: colors.onAccent,
    },
    secondary: {
      main: colors.secondaryButtonBg,
      contrastText: colors.secondaryButtonText,
    },
    error: {
      main: colors.danger,
      contrastText: colors.onDanger,
    },
    success: {
      main: colors.success,
    },
    background: {
      default: colors.background,
      paper: colors.surface,
    },
    text: {
      primary: colors.text,
      secondary: colors.textMuted,
    },
    divider: colors.border,
    action: {
      hover: colors.pressedOverlay,
      selected: colors.rowActiveBg,
      focus: colors.accentMuted,
    },
  },
  shape: {
    borderRadius: radii.sm,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background,
          color: colors.text,
        },
      },
    },
    MuiAppBar: {
      defaultProps: {
        color: 'inherit',
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundColor: colors.background,
          backgroundImage: 'none',
          color: colors.text,
          borderBottom: `1px solid ${colors.border}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: colors.surface,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.surface,
          backgroundImage: 'none',
          borderRight: `1px solid ${colors.border}`,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.inputBg,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          fontWeight: 600,
        },
        outlined: {
          borderColor: colors.border,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          fontWeight: 600,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: colors.border,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: colors.border,
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: colors.modalOverlay,
        },
      },
    },
  },
});
